import cx from 'classnames';
import { ComponentPropsWithRef, useId } from 'react';
import Label from './Label';

export type Option = {
    label: string;
    value: string;
    disabled?: boolean;
};

type Props = Omit<ComponentPropsWithRef<'select'>, 'children' | 'size'> & {
    label: string;
    options: Option[];
    size?: 'lg' | 'sm';
};

const Select = ({ label, options, size, ...props }: Props) => {
    const id = useId();

    return (
        <div>
            <Label name={id} text={label} />
            <select className={cx('form-select', size && `form-select-${size}`)} id={id} name={id} {...props}>
                {options.map((option) => (
                    <option key={option.value} value={option.value} disabled={option.disabled}>
                        {option.label}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default Select;
